










import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';

@Component({
    name: 'ticket-form',
})
export default class TicketForm extends Vue {
    @PropSync('step', { required: true })
    currentStep!: number;

    @PropSync('valid', { type: Boolean, required: true })
    isValid!: boolean;
}
